import { takeLatest, call, put } from 'redux-saga/effects';
import { GET_LIST_ITEMS_ERROR, GET_LIST_ITEMS_START, GET_LIST_ITEMS_SUCCESS } from '../../types';

import apiCall from '../../../api/apiGet';

export function* get({ payload }) {
  try {
    const url = payload.lang ? `/list-items/${payload.lang}` : '/list-items/';
    const method = 'GET';
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, headers);
    console.log(results)
    yield put({ type: GET_LIST_ITEMS_SUCCESS, results: results.data });

  } catch (error) {
    console.log(error)
    yield put({ type: GET_LIST_ITEMS_ERROR, error });
  }
}

export default function* get_list_items() {
  yield takeLatest(GET_LIST_ITEMS_START, get);
}
